import { UPDATABLE_PLAN_FIELDS } from '@/lib/billing/utils/plan-validation'

export type PlanChanges = Record<string, { from: unknown; to: unknown }>

export const PLAN_HISTORY_FIELDS: readonly string[] = ['name', ...UPDATABLE_PLAN_FIELDS]

/** Compares only fields present in `after`; `before = null` (creation) reports every one. */
export function diffPlanSettings(before: object | null, after: object): PlanChanges {
  const previous = before as Record<string, unknown> | null
  const next = after as Record<string, unknown>
  const changes: PlanChanges = {}
  for (const field of PLAN_HISTORY_FIELDS) {
    if (!(field in next)) continue
    const from = previous ? previous[field] ?? null : null
    const to = next[field] ?? null
    if (previous && canonical(from) === canonical(to)) continue
    changes[field] = { from, to }
  }
  return changes
}

function canonical(value: unknown): string {
  return JSON.stringify(value, (_key, nested: unknown) => {
    if (!nested || typeof nested !== 'object' || Array.isArray(nested)) return nested
    return Object.fromEntries(Object.entries(nested).sort(([a], [b]) => a.localeCompare(b)))
  })
}
